/* eslint-disable react-native/no-inline-styles */
/**
 * CartFooter Component
 * 
 * Sticky footer showing cart summary and "View Cart" button
 * - Displays total item count
 * - Shows only when cart has items
 * - Navigates to Cart screen on button press
 * - Supports safe area insets for notched devices
 * - Sticky positioning on web platform
 * 
 * @component
 * @param {Object} props - Component props
 * @param {boolean} [props.isModal] - Whether displayed in modal context
 * @param {Function} [props.closeItemModal] - Callback to close item modal
 */
import React, { } from 'react';
import {
  StyleSheet,
  View,
  Platform,
} from 'react-native';
import { Button, Text } from 'react-native-paper';
import { useSelector } from 'react-redux';
import { safeAreaNavigationBar, theme } from '../../theme/theme';
import { useNavigation } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export default function CartFooter(props) {
  const navigation = useNavigation();
  const insets = useSafeAreaInsets();
  const totalCartItems = useSelector((state) => state.cart?.totalCartItems);

  const gotoCart = () => {
    if (props?.isModal && props?.closeItemModal) {
      props?.closeItemModal(false);
    }
    navigation.push('Cart');
  };

  return (
    <>
      {totalCartItems > 0 && (
        <View style={[styles.container, { backgroundColor: theme.colors.primary }, safeAreaNavigationBar(insets)]}>
          <View>
            <Text variant="titleMedium"
              style={{ color: '#ffffff' }}>{totalCartItems} {totalCartItems === 1 ? 'item' : 'items'} added</Text>
          </View>
          <View>
            <Button
              onPress={gotoCart}
              mode="text"
              labelStyle={{ color: '#ffffff' }}
              icon="chevron-right"
              contentStyle={{ flexDirection: 'row-reverse' }}>
              View Cart
            </Button>
          </View>
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    margin: 0,
    padding: 8,
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: Platform.OS === 'web' ? 'sticky' : undefined,
    bottom: 0,
    width: '100%',
  },
});
